export default __webpack_public_path__ + "static/custom-skyline-73da91220a147586b28a97fe19158364.webp";